import { isNil } from 'lodash';

export const VALIDITY_DATE_FORMAT = 'dddd D MMMM YYYY';

const formatDate = (moment, date) => (isNil(date) ? '' : moment(date).format(VALIDITY_DATE_FORMAT));

export const formatValidity = ({ moment, startDate, endDate }) => ({
    startDate: formatDate(moment, startDate),
    endDate: formatDate(moment, endDate),
});

export default { formatValidity, VALIDITY_DATE_FORMAT };
